import { v4 as uuidv4 } from 'uuid';

export function SellerPriceWithShipping(props = {}, childrenComponents = []) {
	return {
		componentName: 'SellerPriceWithShipping',
		componentId: uuidv4(),
		title: '',
		props: Object.assign({}, props),
		childrenComponents,
	};
}
